import { faker } from "@faker-js/faker/locale/fr"
import { type IsoDate, type KeyFigure, SourceName } from "../../../types"
import type {
  ApiLabPurchases,
  LabPurchaseChannel,
  LabPurchaseSection,
} from "../../laboratoryPurchases"
import type { PurchasesChannelName } from "../../referential"

const mockKeyFigure = (range: {
  min: number
  max: number
}): KeyFigure | null =>
  faker.helpers.maybe(() => ({
    mainStat: faker.number.int(range),
    evolution: faker.number.float({ min: -100, max: 100, fractionDigits: 1 }),
  })) ?? null

const mockIsoDate = (): IsoDate | undefined =>
  faker.helpers.maybe(() =>
    faker.date.recent({ days: 90 }).toISOString().slice(0, 10),
  )

const mockChannel = (
  name: PurchasesChannelName,
  sources: SourceName[],
): LabPurchaseChannel => ({
  name,
  sources,
  purchases: mockKeyFigure({ min: 0, max: 1_000_000 }) ?? null,
  periodStartDate: mockIsoDate(),
  periodEndDate: mockIsoDate(),
})

const mockSection = (
  sources: SourceName[],
  channels: LabPurchaseChannel[],
): LabPurchaseSection | null =>
  faker.helpers.maybe(() => ({
    sources,
    purchases: mockKeyFigure({ min: 0, max: 5_000_000 }) ?? null,
    periodStartDate: mockIsoDate(),
    periodEndDate: mockIsoDate(),
    channels,
  })) ?? null

export const labPerfPurchasesMock = (): ApiLabPurchases => ({
  purchases: mockKeyFigure({ min: 0, max: 10_000_000 }),
  pharmacyCount: mockKeyFigure({ min: 0, max: 5_000 }),
  averageBasket: mockKeyFigure({ min: 0, max: 5_000 }),
  main: mockSection(
    [SourceName.CERP],
    [
      mockChannel("FDL", [SourceName.CERP]),
      mockChannel("SAGITTA", [SourceName.SAGITTA]),
    ],
  ),
  other: mockSection(
    [SourceName.SAGITTA],
    [
      mockChannel("FDL", [SourceName.CERP]),
      mockChannel("SAGITTA", [SourceName.SAGITTA]),
    ],
  ),
})
